import {HistoricalOptionService} from "../option/HistoricalOptionService";
import {OptionChain} from "../option/chain/OptionChain";
import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {OptionsChainController} from "./popup/OptionsChainController";
import {HistoricalOptionRecord, HistoricalPriceResponse} from "../price/historical/HistoricalPriceModels";
import {StaticPriceSource} from "../price/source/StaticPriceSource";
import {Expiries} from "../expiry/Expiries";

export class OptionChainService {

    public static id = "optionChainService";

    private service: HistoricalOptionService;

    /** @ngInject */
    public constructor(historicalOptionService: HistoricalOptionService, private $uibModal: IModalService) {
        this.service = historicalOptionService;
    }

    public async open(underlying: string, asAt: string, previousCode?: string): Promise<HistoricalOptionRecord> {
        const prices = await this.service.get(underlying, asAt);
        const chain = this.buildChain(underlying, prices);
        const historicalUnderlying = prices.underlying;
        const source = StaticPriceSource.from(historicalUnderlying.code, historicalUnderlying.openPrice, asAt);
        const modalOptions: IModalSettings = {
            templateUrl: "app/services/option-chain/popup/OptionsChainTemplate.html",
            size: "lg",
            controllerAs: "ctrl",
            controller: OptionsChainController,
            windowClass: "option-chain-modal",
            resolve: {
                chain: () => chain,
                previousCode: () => previousCode,
                priceSource: () => source
            }
        };
        const instance = this.$uibModal.open(modalOptions);
        return await instance.result;
    }

    public async chainFor(underlying: string, asAt: string): Promise<OptionChain> {
        const prices = await this.service.get(underlying, asAt);
        return this.buildChain(underlying, prices);
    }

    private buildChain(underlying: string, prices: HistoricalPriceResponse): OptionChain {
        const expiries = new Expiries(prices.expiries);
        return new OptionChain(underlying, prices.options, expiries);
    }
}
